export const pagesPath = {
  account_register: {
    $url: (url?: { hash?: string }) => ({
      pathname: '/account-register' as const,
      hash: url?.hash,
    }),
  },
  creator: {
    _uuid: (uuid: string | number) => ({
      $url: (url?: { hash?: string }) => ({
        pathname: '/creator/[uuid]' as const,
        query: { uuid },
        hash: url?.hash,
      }),
    }),
    $url: (url?: { hash?: string }) => ({
      pathname: '/creator' as const,
      hash: url?.hash,
    }),
  },
  episodes: {
    _uuid: (uuid: string | number) => ({
      $url: (url?: { hash?: string }) => ({
        pathname: '/episodes/[uuid]' as const,
        query: { uuid },
        hash: url?.hash,
      }),
    }),
  },
  mypage: {
    edit_avatar: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/mypage/edit-avatar' as const,
        hash: url?.hash,
      }),
    },
    profile: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/mypage/profile' as const,
        hash: url?.hash,
      }),
    },
    $url: (url?: { hash?: string }) => ({
      pathname: '/mypage' as const,
      hash: url?.hash,
    }),
  },
  news: {
    _uuid: (uuid: string | number) => ({
      $url: (url?: { hash?: string }) => ({
        pathname: '/news/[uuid]' as const,
        query: { uuid },
        hash: url?.hash,
      }),
    }),
    $url: (url?: { hash?: string }) => ({
      pathname: '/news' as const,
      hash: url?.hash,
    }),
  },
  notification: {
    _uuid: (uuid: string | number) => ({
      $url: (url?: { hash?: string }) => ({
        pathname: '/notification/[uuid]' as const,
        query: { uuid },
        hash: url?.hash,
      }),
    }),
    $url: (url?: { hash?: string }) => ({
      pathname: '/notification' as const,
      hash: url?.hash,
    }),
  },
  question: {
    $url: (url?: { hash?: string }) => ({
      pathname: '/question' as const,
      hash: url?.hash,
    }),
  },
  rules: {
    community_guidelines: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/community-guidelines' as const,
        hash: url?.hash,
      }),
    },
    company: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/company' as const,
        hash: url?.hash,
      }),
    },
    contact: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/contact' as const,
        hash: url?.hash,
      }),
    },
    privacy_policy: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/privacy-policy' as const,
        hash: url?.hash,
      }),
    },
    service_terms: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/service-terms' as const,
        hash: url?.hash,
      }),
    },
    specific_commercial_transactions: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/specific-commercial-transactions' as const,
        hash: url?.hash,
      }),
    },
    specific_payment_services: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/specific-payment-services' as const,
        hash: url?.hash,
      }),
    },
    anonymous_processed_information: {
      $url: (url?: { hash?: string }) => ({
        pathname: '/rules/anonymous-processed-information' as const,
        hash: url?.hash,
      }),
    },
    $url: (url?: { hash?: string }) => ({
      pathname: '/rules' as const,
      hash: url?.hash,
    }),
  },
  signup: {
    $url: (url?: { hash?: string }) => ({
      pathname: '/signup' as const,
      hash: url?.hash,
    }),
  },
  switch_account: {
    $url: (url?: { hash?: string }) => ({
      pathname: '/switch-account' as const,
      hash: url?.hash,
    }),
  },
  works: {
    _uuid: (uuid: string | number) => ({
      $url: (url?: { hash?: string }) => ({
        pathname: '/works/[uuid]' as const,
        query: { uuid },
        hash: url?.hash,
      }),
    }),
  },
}

export type PagesPath = typeof pagesPath
